import React from "react";
import { Stack } from "@mui/material";
import styled from "styled-components";
import CommitIcon from "@mui/icons-material/Commit";
import CallMergeIcon from "@mui/icons-material/CallMerge";
import GradingIcon from "@mui/icons-material/Grading";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import GroupsIcon from "@mui/icons-material/Groups";

const H2 = styled.h2`
    font-size: 22px;
    font-weight: 500;
    margin: 0;
    color: ${({ theme }) => theme.palette.error.main};
`;

const Span = styled.span`
    font-size: 16px;
    font-weight: 300;
    opacity: 0.35;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const BorderedStack = styled(Stack)`
    border: ${({ theme }) => `3px dashed ${theme.palette.background.paper}`};
    border-radius: 14px;
    // width: 100%;
`;

const AssignIcon = ({ name }) => {
    if (name === "commits")
        return <CommitIcon style={{ width: "50", height: "auto", opacity: "0.3" }} />;
    if (name === "deployments")
        return <PlayCircleOutlineIcon style={{ width: "50", height: "auto", opacity: "0.3" }} />;
    if (name === "merge-requests")
        return <CallMergeIcon style={{ width: "50", height: "auto", opacity: "0.3" }} />;
    if (name === "reviews")
        return <GradingIcon style={{ width: "50", height: "auto", opacity: "0.3" }} />;
    if (name === "collaboration")
        return <GroupsIcon style={{ width: "50", height: "auto", opacity: "0.3" }} />;
    return null;
};

const IntegratedDataLoading = ({ name }) => {
    return (
        <BorderedStack
            spacing={2}
            direction="column"
            justifyContent="center"
            alignItems="center"
            p={10}
            m={3}
        >
            {AssignIcon({ name })}
            <Stack alignItems="center">
                <H2>No data about {name} yet</H2>
                <Span style={{ marginBottom: "3rem" }}>
                    Data is currently being processed. Please wait.
                </Span>
            </Stack>
        </BorderedStack>
    );
};

export default IntegratedDataLoading;
